import React, { useEffect } from "react";
import ModileSlide from "./components/Home/ModileSlide";
import ServiceList from "./components/Services/ServiceList";
import Infobox from "./components/Home/Infobox";
import Contactbynum from "./components/Services/Contactbynum";
import Callsection from "./components/Home/Callsection";
import Whychoose from "./components/Home/Whychoose";
import ServiceReview from "./components/Services/ServiceReview";
import Specilizedser from "./components/Services/Specilizedser";
import ContactwithWat from "./components/Services/ContactwithWat";
import ServiceHome from "./components/Services/ServiceHome";
import { movetop } from "./fun";
import SEO from "./components/SEO";

const Home = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.elvhealthcare.com/#organization",
    name: "ELV Health Care Polyclinics",
    url: "https://www.elvhealthcare.com/",
    description:
      "ELV Health Care Polyclinics is a multi-speciality healthcare provider in Bengaluru offering comprehensive medical, diagnostic, and patient-centric services with expert doctors and advanced care.",
    logo: "https://www.elvhealthcare.com/logo.png",
    address: {
      "@type": "PostalAddress",
      streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
      addressLocality: "Bengaluru",
      addressRegion: "Karnataka",
      postalCode: "560066",
      addressCountry: "IN",
    },
    telephone: "+91-9535264855",
    email: "elvhealthcare@gmail.com",
    geo: {
      "@type": "GeoCoordinates",
      latitude: 12.971389,
      longitude: 77.75013,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "00:00",
      closes: "23:59",
    },
    hasMap: "https://www.google.com/maps/place/Whitefield,+Bengaluru,+Karnataka+560066",
    knowsAbout: [
      "Multi-specialty medical consultations",
      "Diagnostic imaging and lab services",
      "Primary care and chronic disease management",
      "Day care and minor procedures",
      "Pharmacy services",
    ],
    keywords: [
      "Best Multispeciality Clinic in Immadihalli",
      "Best Multispeciality Clinic in Whitefield",
      "Best Multispeciality Clinic in Bangalore",
      "Best Multispeciality Clinic in Kundalahalli",
      "Best Multispeciality Clinic in Pattandur Agrahara",
    ],
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <SEO
        title="Best polyclinic in Vijayanagar"
        description="Are you looking for the best polyclinic in Vijayanagar or in Whitefield? Then you are in the right place. Contact us today."
        jsonLd={jsonLdData}
      />

      {/* <div className="hidden lg:flex">
        <SliderInfo />
      </div> */}
      <ModileSlide />
      <ServiceList />
      {/* <NumberInfo /> */}
      <Infobox />
      <Contactbynum color={"#0f172a"} />
      {/* <div
        style={{
          backgroundImage:
            " linear-gradient(#0f172a, #0f172a), url(../photo/sam.jpg)",
        }}
        className="py-8 bg-cover bg-center bg-fixed"
      > */}
      {/* <NumberInfo test="text-white" /> */}
      {/* </div> */}
      {/* <Speclityslide /> */}
      {/* <Specilities /> */}
      {/* <Specilizedser /> */}
      <ServiceHome />
      <Callsection />
      <Whychoose />
      <ServiceReview />
      <div className="py-0 bg-cover bg-center bg-fixed">
        <ContactwithWat />
      </div>
      <Specilizedser />
      {/* <SecondBlog /> */}
      {/* <Divider /> */}
      {/* <Doctorbox /> */}
      {/* <Youtube /> */}
      {/* <ThreeBoxin /> */}
      {/* <HealthTip /> */}
      {/* <BlogHome /> */}
      {/* <Prequentquation /> */}
      {/* <Qns /> */}
      {/* <Conatinfobox /> */}
      {/* <Qns /> */}

      {/* <Servicebanner />
      <div style={{ backgroundColor: "#e3eff1" }} className="py-0">
        <NumberInfo />
      </div>
      <Doctorbox />
      <Serviceinfo />
      <ServiceReview />
      <Divider />
      <Wecare /> */}
    </>
  );
};

export default Home;
